module.exports = __webpack_public_path__ + "static/media/ALPA-BNB.afa49054.svg";